import {
  normalizeReleaseVersions,
  type ReleaseVersion,
} from '../models/Release/releaseVersions';
import { apiClientWithApi } from '../utils/http';
import {
  extractFileName,
  triggerBlobDownload,
} from '../utils/http/responseHelpers';

export type ManualKind = 'user' | 'admin';

const manuals = {
  user: {
    path: 'release/docs/user-manual',
    fileName: 'Руководство пользователя.docx',
  },
  admin: {
    path: 'release/docs/admin-manual',
    fileName: 'Руководство администратора.docx',
  },
} as const;

export class InvalidManualResponseError extends Error {
  constructor() {
    super('The manual response does not contain a downloadable file.');
    this.name = 'InvalidManualResponseError';
  }
}

export const releaseApi = {
  getVersions: async (
    signal?: AbortSignal,
  ): Promise<readonly ReleaseVersion[]> => {
    const response = await apiClientWithApi.get<unknown>('release/versions', {
      signal,
      timeout: 30000,
    });
    return normalizeReleaseVersions(response.data);
  },

  downloadManual: async (kind: ManualKind): Promise<void> => {
    const manual = manuals[kind];
    // Release documentation belongs to the website API, not the loader API.
    const response = await apiClientWithApi.get<Blob>(manual.path, {
      responseType: 'blob',
      timeout: 60000,
    });
    if (
      !(response.data instanceof Blob) ||
      response.data.size === 0 ||
      /^(?:application\/(?:problem\+)?json|text\/(?:html|plain))/i.test(
        response.data.type,
      )
    ) {
      throw new InvalidManualResponseError();
    }

    triggerBlobDownload(
      response.data,
      extractFileName(response.headers['content-disposition'], manual.fileName),
    );
  },
};
